import React from 'react';
import { Text } from '@perch-labs/shrike';
import { Container } from 'styles';
import { copyFor } from 'config';
import { useQuery } from '@apollo/client';
import { useAccountContext } from 'contexts/account';
import { SolarSavings } from './solar-savings';
import { EnergyProduction } from './energy-production';
import { EnergyEquivalency } from './energy-equivalency';
import { HorizontalScrollingContainer } from './impact-modules.style';
import { GET_ACCOUNT_IMPACT_STATS } from '../dashboard.api';

const getCopy = copyFor('dashboard.standardDashboard.impactModules');

// TODO the skip for the feature flag forces us to handle undefined here
// and in child components. update after release.
interface Props {
  skipImpactStatsQuery: boolean;
}
export const ImpactModules = ({ skipImpactStatsQuery }: Props) => {
  const { selectedAccountId } = useAccountContext();
  const impactStatsQuery = useQuery<
    GetAccountImpactStatsQuery,
    GetAccountImpactStatsQueryVariables
  >(GET_ACCOUNT_IMPACT_STATS, {
    variables: { id: selectedAccountId || -1 },
    skip: skipImpactStatsQuery,
  });
  const { accountImpactStats } = impactStatsQuery.data?.account || {};

  const {
    vnmSavingsExpected,
    vnmSavingsCumulativeCents,
    vnmSavingsLastStatementCents,
    vnmKwhExpected,
    vnmKwhCumulative,
    vnmKwhLastStatement,
  } = accountImpactStats || {};

  if (!vnmSavingsExpected && !vnmKwhExpected) return null;

  // vnmKwhCumulative can be 0 even if they are getting credits
  // which is confusing if we show the energy modules
  const shouldHideEnergyModules =
    vnmKwhCumulative === 0 && vnmSavingsCumulativeCents;

  return (
    <Container margin={{ top: '16px' }}>
      <Text textStyle="heading500" tag="h2" margin={{ bottom: '16px' }}>
        {getCopy('title')}
      </Text>
      <HorizontalScrollingContainer>
        {vnmSavingsExpected && (
          <SolarSavings
            vnmSavingsCumulativeCents={vnmSavingsCumulativeCents}
            vnmSavingsLastStatementCents={vnmSavingsLastStatementCents}
          />
        )}
        {vnmKwhExpected && !shouldHideEnergyModules && (
          <>
            <EnergyProduction
              vnmKwhCumulative={vnmKwhCumulative}
              vnmKwhLastStatement={vnmKwhLastStatement}
            />
            <EnergyEquivalency vnmKwhCumulative={vnmKwhCumulative} />
          </>
        )}
      </HorizontalScrollingContainer>
    </Container>
  );
};
